import { useMutation, useQueryClient } from '@tanstack/react-query';
import PetProfile from 'happypaws-shared/src/Pets/models/PetProfile';
import { api } from 'services/api';

const useAddPets = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (pets: PetProfile[]) => {
      const response = await api.post('/pets', pets);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pets'] });
    },
  });
};

export default useAddPets;
